export const BD_GET_USERLISTACCORDINGROLE_LISTING =
  "BD_GET_USERLISTACCORDINGROLE_LISTING"
export const BD_GET_USERLISTACCORDINGROLE_LISTING_SUCCESS =
  "BD_GET_USERLISTACCORDINGROLE_LISTING_SUCCESS"
export const BD_GET_USERLISTACCORDINGROLE_LISTING_FAILED =
  "BD_GET_USERLISTACCORDINGROLE_LISTING_FAILED"
